import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {Bundle} from '@sportngin/se-commerce-sdk/models/clare';
import {CatalogSummary} from '../../../../../models/clare';
import {ProductManagementErrorInterface} from '../../../../../error/error-handling/product-management-error';
import {
  CreateBundleState,
  CREATE_BUNDLE_FEATURE_KEY,
  getCatalogs,
  getCatalogsLoading,
  getLoading,
  getError,
  getBundles,
} from './create-bundle.reducer';

export const selectCreateBundleFeature: MemoizedSelector<object, CreateBundleState> =
  createFeatureSelector<CreateBundleState>(CREATE_BUNDLE_FEATURE_KEY);

export const selectCreateBundleLoading: MemoizedSelector<object, boolean> = createSelector(
  selectCreateBundleFeature,
  getLoading
);

export const selectCreateBundleCatalogs: MemoizedSelector<object, CatalogSummary[]> = createSelector(
  selectCreateBundleFeature,
  getCatalogs
);

export const selectCreateBundleCatalogsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectCreateBundleFeature,
  getCatalogsLoading
);

export const selectCreateBundleError: MemoizedSelector<object, ProductManagementErrorInterface | undefined> =
  createSelector(selectCreateBundleFeature, getError);

export const selectBundles: MemoizedSelector<object, Bundle[]> = createSelector(selectCreateBundleFeature, getBundles);

export const selectBundleId: MemoizedSelector<object, number | undefined> = createSelector(
  selectCreateBundleFeature,
  state => {
    const bundles = getBundles(state);
    const first = bundles.length > 0 ? bundles[0] : undefined;
    return first?.id;
  }
);
